import { getDate, getUnixDate } from "@/helpers/date.helpers"
import * as CONST from "../const/date.constants"

export const getTimeDisplayFormatFromString = <
  T extends string | undefined | null
>(
  value: T,
  format = CONST.TIME_FORMAT
): T => {
  try {
    if (!value) return value

    const isRangeDelimiter = value.indexOf(CONST.RANGE_DELIMITER) !== -1
    const splitSymbol = isRangeDelimiter
      ? CONST.RANGE_DELIMITER
      : CONST.RANGE_DELIMITER_QUERY_STRING

    return value
      .split(splitSymbol)
      .map((d) => {
        const num = Number(`${d}`.trim())
        const val = Number.isInteger(num) ? num * 1000 : d

        if (format === "timestamp") return getUnixDate(val)

        return getDate(val).format(format)
      })
      .join(CONST.RANGE_DELIMITER) as T
  } catch {
    return value
  }
}
